
import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Recommendation } from '@/types/assessment';
import SimpleRecommendationItem from './SimpleRecommendationItem';

interface QuestionRecommendationGroupProps {
  questionText: string;
  recommendations: Recommendation[];
  forceExpanded?: boolean;
}

const QuestionRecommendationGroup: React.FC<QuestionRecommendationGroupProps> = ({
  questionText,
  recommendations,
  forceExpanded = false
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <div className="border-l-2 border-muted ml-4">
      <button
        onClick={() => !forceExpanded && setIsExpanded(!isExpanded)}
        className="flex items-center gap-2 w-full text-left p-2 pl-4 hover:bg-muted/50 rounded-r"
        disabled={forceExpanded}
      >
        {(forceExpanded || isExpanded) ? (
          <ChevronDown className="h-4 w-4 text-muted-foreground" />
        ) : (
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
        )}
        <span className="font-medium text-sm">{questionText}</span>
        <span className="text-xs text-muted-foreground ml-auto">
          ({recommendations.length} recommendation{recommendations.length !== 1 ? 's' : ''})
        </span>
      </button>
      
      {(forceExpanded || isExpanded) && (
        <div className="pl-6 pb-2">
          {recommendations.map(recommendation => (
            <SimpleRecommendationItem 
              key={recommendation.id}
              text={recommendation.text}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default QuestionRecommendationGroup;
